// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4755":"c960b12c","7870":"bab99d9f"}[chunkId] + ".chunk.css";
};